import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconEditDraftVariation } from 'src/assets/icons/IconEditDraftVariation';
import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';

import { useStyles } from './useStyles';

export const EditButton = ({ className, onClick, disabled }) => {
  const styles = useStyles();

  return (
    <CustomButton
      className={cx(styles.root, className)}
      variant={CUSTOM_BUTTON_VARIANT.text}
      color={CUSTOM_BUTTON_COLOR.primary}
      startIcon={<IconEditDraftVariation />}
      onClick={onClick}
      disabled={disabled}
    >
      Edit
    </CustomButton>
  );
};

EditButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
EditButton.defaultProps = {
  className: null,
  disabled: false,
};
